import { render, staticRenderFns } from "./catalogFull.vue?vue&type=template&id=0702802b"
import script from "./catalogFull.vue?vue&type=script&lang=js"
export * from "./catalogFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports